import { toast } from "react-toastify";
import { executePost } from "../ServiceMethods";
import { SessionTimeout } from "../ErrorMessages";
import { removeUserCredentials } from "../LocalStorage";

export const VoucherDashBoardAPI = async (data, cb) => {
  try {
    const voucherDashBoardAPI = await executePost(
      "/businessUser/voucherDashboard",
      data
    );
    const voucherDashBoardData = voucherDashBoardAPI.data
      ? voucherDashBoardAPI.data
      : {};
    return voucherDashBoardData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
